import { Vector3, MathUtils, Vector3} from 'three'


import { Easing, Tween, update as tweenUpdate } from '@tweenjs/tween.js'

import { sceneManager} from '../script.js'


export function cameraLabelClick(name, object) {
  if (sceneManager.commands.controls.timeUnit === 'Sec') {
    sceneManager.commands.controls.camTarget = name.toLowerCase();
    sceneManager.commands.controls.mode = 'Automatic';
    updateTween(sceneManager.camera, object);
  } else {
    const msg = document.createElement('div');
    msg.className = 'temp-message';
    msg.textContent = 'Auto mode in real time only (Sec)';
    document.body.appendChild(msg);

    setTimeout(() => {
      msg.classList.add('hide'); 
      setTimeout(() => {
        if (msg.parentNode) {
          msg.parentNode.removeChild(msg);
        }
      }, 200);
    }, 2000);
  }
}

let camLookTarget
let objectPos
let posCloser

function init() {
  camLookTarget = new Vector3()
  objectPos = new Vector3()
  posCloser = new Vector3()
}
init()

function updateOrbitControls(camera,object) {
  const getPos = getPositionObject(object, camera);
  tweenUpdate();
  sceneManager.orbitC.enabled = true;
  sceneManager.orbitC.target.copy(getPos.objectPos);
  sceneManager.orbitC.minDistance = object.size * 2.5;
  sceneManager.orbitC.update();
}

function updateFreeCamera(controls, distCloser) {
  tweenUpdate();
  sceneManager.fly.movementSpeed = controls.speedCam * distCloser;
  sceneManager.fly.rollSpeed = controls.speedRotCam;
  sceneManager.fly.update(0.01);
}

function getPositionObject(object, camera) {

  object.mesh.getWorldPosition(objectPos);

  const direction = new Vector3();
  direction.subVectors(camera.position, objectPos).normalize();

  const target = new Vector3();
  target.copy(objectPos).add(direction.multiplyScalar(object.size * 4));

  camLookTarget.copy(objectPos);

  return { target, objectPos };
}

export function updateCamFor(controls, object, camera, distCloser) {
  sceneManager.orbitC.enabled = false;
  const strategies = {
    'Automatic': () => updateTween(camera, object),
    'Orbit': () => updateOrbitControls(camera, object),
    'Free Camera': () => updateFreeCamera(controls, distCloser)
  };
  const strategy = strategies[controls.mode];
  if (strategy) {
    strategy();
  } else {
    console.warn('Invalid Mode', controls.mode);
  }
}

const posRepulse = new Vector3();
const dir = new Vector3();
const clampedPos = new Vector3();

export function detectCollision(object) {
  object.mesh.getWorldPosition(posRepulse);
  
  const margin = object.size*0.25;
  const minDist = Math.max(object.size + margin, 5e-5);

  dir.subVectors(sceneManager.camera.position, posRepulse);
  const dist = dir.length();

  if (dist < minDist) {
    clampedPos.copy(posRepulse).add(dir.normalize().multiplyScalar(minDist));
    sceneManager.camera.position.copy(clampedPos);
  }
}
export function findClosestBody(camera, objects) {
  let minDist = Infinity;
  let labelCloser

  for (let key in objects) {
    if (objects.hasOwnProperty(key)) {
      let object = objects[key];
      if (object.mesh) {
        object.mesh.getWorldPosition(posCloser)
        let distance = camera.position.distanceTo(posCloser);
        if (distance < minDist) {
          minDist = distance;
          labelCloser = key;
        }
      }
    }
  }
  return {minDist:minDist, labCloser:labelCloser };
}


export function updateTween(camera, object) {

  const { target, objectPos } = getPositionObject(object, camera);

  tweenUpdate();

  const startPosition = camera.position.clone();
  new Tween(startPosition)
    .to({ x: target.x, y: target.y, z: target.z }, 2000)
    .easing(Easing.Quadratic.Out)
    .onUpdate(function (coords) {
      camera.position.set(coords.x, coords.y, coords.z);
    })
    .start();

  new Tween(camLookTarget)
    .to({ x: objectPos.x, y: objectPos.y, z: objectPos.z }, 1000)
    .easing(Easing.Quadratic.Out)
    .onUpdate(() => camera.lookAt(camLookTarget))
    .start();

  const dist = camera.position.distanceTo(objectPos);
  if (dist < object.size * 10) {
   sceneManager.commands.controls.mode = 'Orbit';
   sceneManager.commands.cameraModeController.updateDisplay()
  }
}